import { Http } from '@/lib/http';

export class ReferenceTypes extends Http {
  endpoint = 'onboarder/settings/reference-types';

  constructor() {
    super();
  }

  fetchReferenceTypes() {
    return this.httpClient().get(this.endpoint);
  }

  updateReferenceType(id, updates) {
    return this.httpClient().patch(`${this.endpoint}/${id}`, updates);
  }

  createReferenceType(referenceType) {
    return this.httpClient().post(this.endpoint, referenceType);
  }

  deleteReferenceType(id) {
    return this.httpClient().delete(`${this.endpoint}/${id}`);
  }
}
